import { voltFetch } from "../voltApi";
import type {
  FundingChange,
  FundingListResponse,
  FundingLogEntry,
  FundingSaved,
  Scale,
} from "./types";

const call = <T>(path: string, init?: RequestInit) =>
  voltFetch<T>(`/funding-list/api${path}`, init);

export const fundingListApi = {
  /** Without a year the API answers with the latest one. */
  list: (year?: number) =>
    call<FundingListResponse>(year ? `/list?jahr=${year}` : "/list"),
  scale: () => call<Scale>("/scale"),
  change: (id: number, version: number, change: FundingChange) =>
    call<FundingSaved>(`/applications/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ ...change, version }),
    }),
  log: (id: number) => call<FundingLogEntry[]>(`/applications/${id}/log`),
};
